'use strict';

var _regeneratorRuntime = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _objectSpread = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectSpread2");

var _asyncToGenerator = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var addAll = require('./add-all.js');

var last = require('it-last');

var configure = require('../lib/configure.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var last__default = /*#__PURE__*/_interopDefaultLegacy(last);

function createAdd(config) {
  var all = addAll.createAddAll(config);
  return configure.configure(function () {
    function add(_x) {
      return _add.apply(this, arguments);
    }

    function _add() {
      _add = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path) {
        var options,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                return _context.abrupt("return", last__default["default"](all([_objectSpread({
                  path: path
                }, options)], options)));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _add.apply(this, arguments);
    }

    return add;
  })(config);
}

exports.createAdd = createAdd;